import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { BLACK } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const keyStyle = {
  fontSize: '16px',
  fontFamily: PRIMARY_FONT[700],
  display: 'inline-block',
};

const valueStyle = {
  fontSize: '16px',
  fontFamily: PRIMARY_FONT[400],
};

const KeyValuePair = ({ name, value, keyColor = BLACK[100], valueColor = BLACK[100] }) => (
  <Box
    sx={{
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      flexWrap: 'wrap',
      minWidth: 0,
    }}
  >
    <Typography sx={{ ...keyStyle, color: keyColor, minWidth: { xs: 'auto', md: '120px' } }}>
      {name}
    </Typography>
    <Typography sx={{ ...valueStyle, color: valueColor, wordBreak: 'break-word' }}>
      {value}
    </Typography>
  </Box>
);

KeyValuePair.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  keyColor: PropTypes.string,
  valueColor: PropTypes.string,
};

export default KeyValuePair;
